import Slick from 'slick-carousel';

export default class Carousel {
    constructor(element) {
        this._element = element;
    }

    init() {
        $(this._element).slick({
            slidesToShow: 1, 
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            adaptiveHeight: true
        })
    }
}


// WEBPACK FOOTER //
// ./assets/scripts/front/App/Carousel.js